import { useNavigate, useLocation } from "react-router-dom";
import { House, ArrowLeft, MagnifyingGlass } from "@phosphor-icons/react";

/**
 * Friendly in-app 404 for React-router routes that don't match.
 *
 * NOTE: This page ONLY renders when nginx correctly serves `index.html`
 * for unknown paths (SPA fallback). If nginx returns its OWN default 404
 * page (blue theme, "Server Error 404 Page Not Found"), then nginx is
 * missing the `try_files $uri $uri/ /index.html;` directive — see
 * ONBOARDING.md section 8.6.
 */
export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = window.history.length > 1;

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-[var(--bg-surface-hover)] flex items-center justify-center">
            <MagnifyingGlass size={32} weight="duotone" className="text-[var(--text-muted)]" />
          </div>
        </div>
        <h1 className="font-display text-2xl font-bold tracking-tight mb-2">
          Táto stránka nie je dostupná
        </h1>
        <p className="text-sm text-[var(--text-secondary)] mb-6 leading-relaxed">
          Odkaz je buď neplatný alebo stránka bola premenovaná.
          Ak ste sa sem dostal cez záložku po nedávnej zmene, skúste vyhľadať stredisko znovu.
        </p>
        <div className="text-xs text-[var(--text-muted)] mb-6 font-mono break-all bg-[var(--bg-page)] rounded px-3 py-2">
          {location.pathname}
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {canGoBack && (
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn-secondary text-sm inline-flex items-center gap-2"
              data-testid="not-found-back-btn"
            >
              <ArrowLeft size={16} /> Späť
            </button>
          )}
          <button
            type="button"
            onClick={() => navigate("/")}
            className="btn-primary text-sm inline-flex items-center gap-2"
            data-testid="not-found-home-btn"
          >
            <House size={16} /> Späť na hlavnú
          </button>
        </div>
      </div>
    </div>
  );
}
